
import { Check } from "../../../../assets/icons";

export default function StateSection({ payment }) {
	const isDone = payment.state === "done";

	return (
		<section
			className={[
				"relative overflow-hidden rounded-[14px] border px-5 py-6 text-center",
				isDone
					? "border-secondary-green2/40 bg-gradient-to-br from-[#EAF8F2] via-white to-lightCta/30"
					: "border-red-200/80 bg-gradient-to-br from-red-50/80 via-white to-lightCta/20",
			].join(" ")}
			aria-live="polite"
		>
			{isDone && (
				<div
					className="pointer-events-none absolute -left-6 -top-6 h-20 w-20 rounded-full bg-secondary-green2/15 blur-2xl"
					aria-hidden
				/>
			)}

			<div
				className={[
					"relative mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full ring-2",
					isDone
						? "bg-white ring-secondary-green2/30 text-secondary-green2"
						: "bg-white ring-red-200 text-[#cc0000]",
				].join(" ")}
			>
				{isDone ? (
					<span className="scale-125 [&_path]:stroke-secondary-green2 [&_rect]:stroke-secondary-green2">
						<Check />
					</span>
				) : (
					<span className="font-Vazir-700 text-[22px] leading-none" aria-hidden>
						×
					</span>
				)}
			</div>

			<p
				className={[
					"relative font-Vazir-700 text-[16px] md:text-[17px]",
					isDone ? "text-darkBlue" : "text-[#cc0000]",
				].join(" ")}
			>
				{isDone ? "پرداخت با موفقیت انجام شد" : "پرداخت ناموفق بود"}
			</p>
			<p className="relative mt-2 font-Vazir-400 text-[13px] text-darkBlue/55">
				{isDone
					? "رسید این تراکنش در حساب شما ثبت شده است."
					: "در صورت کسر وجه، طی ۷۲ ساعت به حساب شما بازمی‌گردد."}
			</p>
		</section>
	);
}
